import './CompetitionCard.scss'

import Button from '../../../components/Button/Button'
import Checkbox from '../../Checkbox/Checkbox'
import Icon from '../../../components/Icon/Icon'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import t from '../../../helpers/i18n'

const CompetitionCard = ({
  competition_id,
  name,
  tags,
  logo,
  teamsCount,
  emailsCount,
  address,
  onClick,
}) => {

  const handleClick = useCallback(() => {
    if (onClick) onClick(competition_id)
  }, [onClick, competition_id])

  return (
    <div className='competition-card-module'>
      <div className='-header'>
        <div className='-controls'>
          <div className='-menu'>
            <Checkbox />
            <div className="-divider" />
            <Icon size={16} icon='MoreIcon' />
          </div>
          <div className='-competition-name proper-noun-large-semibold'>
            {name}
          </div>
          {tags && tags.map((tag, index) => (
            <div key={index} className='-tags overline-label-small-basic'>
              <span>{tag}</span>
            </div>
          ))}
        </div>
        <div className='-logo'>
          {logo && <img src={logo} alt='' />}
        </div>
      </div>

      <div className='-description'>
        <div className='-row'>
          <div className='-label label-small-basic'>{t('labels.Location')}</div>
          <div className='-data proper-noun-small-medium'>{address}</div>
        </div>

        <div className='-buttons'>
          <div className="-button label-small-basic"><Icon icon="CompetitionsIcon" size="24" />{teamsCount}</div>
          <div className="-button label-small-basic"><Icon icon="DelegatesIcon" size="24" />{emailsCount}</div>
        </div>
      </div>

      <div className='-main-button'>
        <Button
          size='field-sized'
          type='light'
          color='green'
          label={t('buttons.Open_Competition')}
          icon='ArrowRightIcon'
          iconPosition='trailing'
          grow
          onClick={handleClick}
        />
      </div>
    </div>
  )
}

CompetitionCard.propTypes = {
  name: PropTypes.string,
  tags: PropTypes.array,
  logo: PropTypes.string,
  teamsCount: PropTypes.number,
  emailsCount: PropTypes.number,
  address: PropTypes.string,
  onClick: PropTypes.func,
}

CompetitionCard.defaultProps = {}

export default CompetitionCard
